import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { EventModel, EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { TooltipModule } from '@frontend/sports/tooltip-feature';

import { TreeParticipantComponent } from './tree-participant.component';

@Component({
    selector: 'ms-tree-event-name',
    templateUrl: 'tree-event-name.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TooltipModule, TreeParticipantComponent],
})
export class TreeEventNameComponent implements OnInit, OnChanges {
    @Input() event: EventModel;
    @HostBinding('class') className = 'tree-event-name';

    view: string;
    option: string | undefined;
    leader: boolean;

    ngOnInit(): void {
        this.setProperties();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['event'] && !changes['event'].isFirstChange()) {
            this.setProperties();
        }
    }

    private setProperties(): void {
        this.view = this.getView();
        this.option = this.getOption();
        this.leader = this.getLeader();
    }

    private getView(): string {
        if (this.event.league.combiLeague) {
            return 'Combi';
        } else if (this.event.participants.length === 2 && !this.event.isTournamentGame()) {
            return 'Pair';
        }

        return 'Tournament';
    }

    private getOption(): string | undefined {
        const optionGroup = this.event.optionGroups && this.event.optionGroups[0];

        if (!optionGroup) {
            return '';
        }

        const singleOption = optionGroup.options && optionGroup.options.length === 1;

        return singleOption ? optionGroup.options[0].name : optionGroup.name;
    }

    private getLeader(): boolean {
        if (!this.event.isTournamentGame() || !this.event.scoreboard || this.event.scoreboard.isGeneralTournament) {
            return false;
        }

        return this.event.scoreboard.started && this.event.participants.length > 0;
    }

    trackParticipant(participant: EventParticipant): number {
        return participant.id!;
    }
}
